import { convertHexToRgbA } from '../utils';

export const BACKGROUND = {
	main: '#2D083E',
	secondary: '#190323',
	snackbar: '#190323',
	input: '#351A43',
	modalView: convertHexToRgbA('#190323', 0.8),
	modalViewSecondary: convertHexToRgbA('#2D083E', 0.8)
};

export const ICON = {
	main: '#bba1dd',
	secondary: '#9D93AA',
	chevron: '#AE6FFF',
	hover: '#C190FF',
	pressed: '#9449F4',
	alwaysWhite: '#ffffff',
	notification: '#F92F2F',
	warning: '#f1c40f',
	deposit: '#33B98D'
};

export const CONTROL = {
	primary: '#FD4C0A',
	hover: '#CA3D07',
	pressed: '#A23106',
	disabled: '#331B43',
	secondary: '#EAD40C',
	secondaryHover: '#BBAA0A',
	secondaryPressed: '#BBAA0A',
	dark: '#3A2159',
	darkHover: '#4A2C6F',
	darkPressed: '#3B2359',
	darkToggle: '#614D7B',
	light: '#ffffff',
	lightHover: '#E5E5E5',
	lightPressed: '#D9D9D9',
	lightToggle: '#B7B7B7'
};

export const TEXT = {
	title: '#F9F8FA',
	subtitle: '#D8CEDF',
	body: '#C8C1CF',
	link: '#07EF9C',
	error: '#FF1100',
	warning: '#f1c40f',
	alwaysWhite: '#ffffff',
	alwaysDark: '#242129'
};

export const OTHER = {
	calendarDefault: convertHexToRgbA('#190323', 0.8),
	calendarActive: '#190323',
	calendarBackgroundWhite: convertHexToRgbA('#ffffff', 0.25),
	calendarTextWhite: '#ffffff',
	calendarBackgroundDarkYellow: '#333217',
	calendarTextYellow: '#EAAE16',
	calendarBackgroundDarkGreen: '#014A2E',
	calendarTextGreen: '#00D07F',
	calendarBackgroundDarkPurple: '#3A2159',
	calendarTextPurple: '#8F6ED4',
	calendarBackgroundDarkBlue: '#19334F',
	calendarTextBlue: '#1D92FF'
};
